module.exports = __webpack_public_path__ + "img/NFC-2.c211404e.png";